/* ELUENA Premium Experience — isolated enhancement layer */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initAmbient() {
    if (reduced) return;
    var root = document.documentElement;
    var raf = 0;
    function update(x, y) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        root.style.setProperty('--eluena-pointer-x', x + 'px');
        root.style.setProperty('--eluena-pointer-y', y + 'px');
        raf = 0;
      });
    }
    window.addEventListener('pointermove', function (e) { update(e.clientX, e.clientY); }, { passive: true });
    window.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches[0]) update(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
  }

  function initScrollReveal(scope) {
    scope = scope || document;
    var selectors = [
      'main section > .page-width',
      '.product-card',
      '.trust-item',
      '.testimonial',
      '.philosophy-content',
      '.routine-card'
    ];
    var nodes = scope.querySelectorAll(selectors.join(','));
    nodes.forEach(function (el, index) {
      if (el.classList.contains('eluena-scroll-reveal')) return;
      el.classList.add('eluena-scroll-reveal');
      el.style.setProperty('--eluena-reveal-delay', Math.min(index % 4, 3) * 75 + 'ms');
    });
    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('eluena-in-view'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('eluena-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .08, rootMargin: '0px 0px -7% 0px' });
    nodes.forEach(function (el) { if (!el.classList.contains('eluena-in-view')) observer.observe(el); });
  }

  function initLightbox(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.eluenaLightboxReady === 'true') return;
      var main = gallery.querySelector('[data-gallery-main]');
      if (!main) return;
      gallery.dataset.eluenaLightboxReady = 'true';
      var sources = [];
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        var src = thumb.getAttribute('data-full-src') || thumb.getAttribute('data-src');
        if (src) sources.push(src);
      });
      if (!sources.length && main.src) sources.push(main.src);
      var active = 0;

      var hint = document.createElement('button');
      hint.type = 'button';
      hint.className = 'eluena-gallery-hint';
      hint.setAttribute('aria-label', 'Otvoriť galériu na celú obrazovku');
      hint.innerHTML = '<span aria-hidden="true">⌗</span>';
      main.parentElement.appendChild(hint);

      var modal = document.createElement('div');
      modal.className = 'eluena-lightbox';
      modal.setAttribute('data-open', 'false');
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Galéria produktu');
      modal.innerHTML = '<div class="eluena-lightbox__top"><span class="eluena-lightbox__title">ELUENA · PRODUCT VIEW</span><button type="button" class="eluena-lightbox__close" aria-label="Zatvoriť">×</button></div>' +
        '<div class="eluena-lightbox__stage"><button type="button" class="eluena-lightbox__nav" data-prev aria-label="Predchádzajúca fotografia">‹</button><div class="eluena-lightbox__image-wrap"><img class="eluena-lightbox__image" alt=""></div><button type="button" class="eluena-lightbox__nav" data-next aria-label="Nasledujúca fotografia">›</button></div>' +
        '<div class="eluena-lightbox__counter"></div>';
      document.body.appendChild(modal);
      var image = modal.querySelector('.eluena-lightbox__image');
      var counter = modal.querySelector('.eluena-lightbox__counter');
      function render() {
        image.src = sources[active];
        image.alt = main.alt || '';
        counter.textContent = (active + 1) + ' / ' + sources.length;
        modal.querySelectorAll('.eluena-lightbox__nav').forEach(function (button) { button.hidden = sources.length < 2; });
      }
      function open() {
        var current = main.currentSrc || main.src;
        var found = sources.findIndex(function (src) { return current.indexOf(src.split('?')[0]) > -1 || src.indexOf(current.split('?')[0]) > -1; });
        if (found > -1) active = found;
        render();
        modal.setAttribute('data-open', 'true');
        document.body.style.overflow = 'hidden';
        modal.querySelector('.eluena-lightbox__close').focus();
      }
      function close() { modal.setAttribute('data-open', 'false'); document.body.style.overflow = ''; hint.focus(); }
      function move(delta) { active = (active + delta + sources.length) % sources.length; render(); }
      hint.addEventListener('click', open);
      main.addEventListener('click', open);
      modal.querySelector('.eluena-lightbox__close').addEventListener('click', close);
      modal.querySelector('[data-prev]').addEventListener('click', function () { move(-1); });
      modal.querySelector('[data-next]').addEventListener('click', function () { move(1); });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) {
        if (modal.getAttribute('data-open') !== 'true') return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') move(-1);
        if (e.key === 'ArrowRight') move(1);
      });
    });
  }


  function initEditorialSections(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-eluena-routine]').forEach(function (section) {
      if (section.dataset.eluenaRoutineReady === 'true') return;
      section.dataset.eluenaRoutineReady = 'true';
      var steps = Array.prototype.slice.call(section.querySelectorAll('[data-routine-step]'));
      var track = section.querySelector('.routine-luxe__track');
      if (!steps.length || !track) return;
      function activate(index) {
        steps.forEach(function (step, i) { step.classList.toggle('is-active', i <= index); });
        var progress = steps.length > 1 ? (index / (steps.length - 1)) * 90 + 5 : 100;
        track.style.setProperty('--routine-progress', progress + '%');
      }
      if (reduced || !('IntersectionObserver' in window)) { activate(steps.length - 1); return; }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { activate(Number(entry.target.style.getPropertyValue('--eluena-step-index')) || 0); }
        });
      }, { threshold: .58, rootMargin: '-8% 0px -26% 0px' });
      steps.forEach(function (step) { observer.observe(step); });
    });
  }

  function init(scope) {
    initScrollReveal(scope || document);
    initLightbox(scope || document);
    initEditorialSections(scope || document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAmbient(); init(); });
  else { initAmbient(); init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
